/* eslint-disable react/jsx-no-literals */
/* eslint-disable complexity */
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { getCurrencySymbolFromCode } from '@futrli/localisation';

import * as styles from '../content.scss';
import { PredictManagementContext } from '../../../predict-management/context/predict-management-context';

export const EmptyBusinessInsightsInfoList = () => {
  const { currency } = useContext(PredictManagementContext);

  return (
    <ul className={styles.bulletList}>
      <li>
        <FormattedMessage
          id="onboarding.sales_mov_target_value"
          defaultMessage="Sales are above/under target by {emptyValue}"
          values={{
            emptyValue: (
              <span style={{ color: '#026902', fontWeight: 500 }}>+{getCurrencySymbolFromCode(currency || '')}-</span>
            )
          }}
        />
      </li>
      <li>
        <FormattedMessage
          id="onboarding.costs_mov_target_value"
          defaultMessage="Costs are above/under target by {emptyValue}"
          values={{
            emptyValue: (
              <span style={{ color: '#026902', fontWeight: 500 }}>-{getCurrencySymbolFromCode(currency || '')}-</span>
            )
          }}
        />
      </li>
      <li>
        <FormattedMessage
          id="onboarding.expenses_mov_target_value"
          defaultMessage="Expenses are above/under target by {emptyValue}"
          values={{
            emptyValue: (
              <span style={{ color: '#A42D3C', fontWeight: 500 }}>+{getCurrencySymbolFromCode(currency || '')}-</span>
            )
          }}
        />
      </li>
      <li>
        <FormattedMessage
          id="onboarding.net_profit_mov_target_value"
          defaultMessage="Net profit is above/under target by {emptyValue}"
          values={{
            emptyValue: (
              <span style={{ color: '#A42D3C', fontWeight: 500 }}>-{getCurrencySymbolFromCode(currency || '')}-</span>
            )
          }}
        />
      </li>
      <li>
        <FormattedMessage
          id="onboarding.available_cash_mov_target_value"
          defaultMessage="Available cash is above/under target by {emptyValue}"
          values={{
            emptyValue: (
              <span style={{ color: '#A42D3C', fontWeight: 500 }}>-{getCurrencySymbolFromCode(currency || '')}-</span>
            )
          }}
        />
      </li>
    </ul>
  );
};
